import { CAROUSEL_CARD_STYLES, Carousel } from '@components/primitives/Carousel'
import { Text } from '@components/primitives/Text'
import type { TrackingSources } from '@lib/tracking/TrackingSources'
import type { TrialForGradientCard } from '@modules/trials/helpers/getRelatedListings'
import { TrialSummaryCard } from '../TrialSummaryCard'

export type RelatedListingLinksProps = {
  relatedListings?: TrialForGradientCard[] | null
  title?: string
  trackingSource: TrackingSources
}

/**
 * Render a list of links to trials from the Graphite Interlinking API as narrow trial cards.
 *
 * @param relatedListings List of trials to display
 */
export default function RelatedListingLinks({
  relatedListings,
  title = 'Other Trials to Consider',
  trackingSource,
}: RelatedListingLinksProps) {
  const relatedTrials = relatedListings ?? []

  if (relatedTrials.length < 1) {
    return null
  }

  return (
    <section id='related-trials'>
      <div className='mx-auto grid max-w-screen-2xl grid-cols-1 gap-4'>
        <Text
          className='text-neutral900'
          element={'h3'} // We want H3 for SEO, children should be most H4
          styleName='h4'
          value={title}
        />
        <Carousel centerVertically={false} className='gap-4'>
          {relatedTrials.map((trial, index) => (
            <TrialSummaryCard.Photo
              className={CAROUSEL_CARD_STYLES}
              key={`trial-${index}`}
              trackingSource={trackingSource}
              trial={trial}
            />
          ))}
        </Carousel>
      </div>
    </section>
  )
}
